import { baseConfig } from '../base.config';
import { mix } from '@oec-seller/sdk/m4b-seller-material';
import { LANG } from '@/constants/index';
export const REGION_CONFIG = mix(baseConfig, {
  features: {
    showRegionItem: true,
    defaultRegion: 'MX',
    privacyPolicyLink: 'https://seller-mx.tiktok.com/university/essay?knowledge_id=6295443664750337&identity=1'
  },
  language: {
    switchLang: [LANG.EN, LANG.ES_419, LANG.ZH_CN],
    defaultLang: LANG.ES_419
  }
} as Partial<typeof baseConfig>);
